import React from 'react';
import { cn } from '../../../lib/utils';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { SlidePackageDialogProps } from '../types';

export function SlidePackageDialog({
  isDark,
  isOpen,
  onOpenChange,
  formData,
  onFormDataChange,
  onSubmit,
  title,
  description,
  submitLabel,
}: SlidePackageDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          'max-w-3xl max-h-[90vh] overflow-y-auto',
          isDark ? 'bg-[#1E293B] border-slate-700' : 'bg-white',
        )}
      >
        <DialogHeader>
          <DialogTitle className={cn(isDark ? 'text-white' : 'text-[#0F172A]')}>{title}</DialogTitle>
          <DialogDescription className={cn(isDark ? 'text-slate-400' : 'text-slate-500')}>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>Code *</Label>
              <Input
                value={formData.code}
                onChange={(e) =>
                  onFormDataChange((prev) => ({ ...prev, code: e.target.value.toUpperCase() }))
                }
                placeholder="SLIDES_STARTER"
                className={cn(isDark ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200')}
              />
            </div>
            <div className="space-y-2">
              <Label className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>Decks Included *</Label>
              <Input
                type="number"
                value={formData.decks_included}
                onChange={(e) =>
                  onFormDataChange((prev) => ({ ...prev, decks_included: parseInt(e.target.value) || 0 }))
                }
                className={cn(isDark ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200')}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>Name (UZ) *</Label>
              <Input
                value={formData.name_uz}
                onChange={(e) => onFormDataChange((prev) => ({ ...prev, name_uz: e.target.value }))}
                placeholder="Slides Starter — 5 ta deck"
                className={cn(isDark ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200')}
              />
            </div>
            <div className="space-y-2">
              <Label className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>Name (RU) *</Label>
              <Input
                value={formData.name_ru}
                onChange={(e) => onFormDataChange((prev) => ({ ...prev, name_ru: e.target.value }))}
                placeholder="Стартовый — 5 деков"
                className={cn(isDark ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200')}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>Price (UZS) *</Label>
              <Input
                type="number"
                value={formData.price_uzs}
                onChange={(e) =>
                  onFormDataChange((prev) => ({ ...prev, price_uzs: parseInt(e.target.value) || 0 }))
                }
                className={cn(isDark ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200')}
              />
            </div>
            <div className="space-y-2">
              <Label className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>Display Order</Label>
              <Input
                type="number"
                value={formData.display_order ?? 0}
                onChange={(e) =>
                  onFormDataChange((prev) => ({ ...prev, display_order: parseInt(e.target.value) || 0 }))
                }
                className={cn(isDark ? 'bg-slate-800 border-slate-700 text-white' : 'bg-white border-slate-200')}
              />
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Switch
              checked={formData.is_active ?? true}
              onCheckedChange={(checked) =>
                onFormDataChange((prev) => ({ ...prev, is_active: checked }))
              }
            />
            <Label className={cn(isDark ? 'text-slate-300' : 'text-slate-700')}>Active</Label>
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className={cn(
              isDark ? 'border-slate-700 text-slate-300 hover:bg-slate-800' : 'border-slate-200',
            )}
          >
            Cancel
          </Button>
          <Button onClick={onSubmit} className="bg-[#0EA5A4] hover:bg-[#0EA5A4]/90">
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
